/** Official operator references reviewed on 8 September 2026. Links do not certify our geometry. */
export const OFFICIAL_SKI_MAP_REFERENCES: Readonly<Record<string, string>> = {
  "portes-du-soleil": "https://en.portesdusoleil.com/in-winter/openings-slopes-and-lifts/",
  "les-3-vallees": "https://www.les3vallees.com/en/guide/the-world-s-largest-ski-area/ski-area-map",
  "paradiski": "https://www.la-plagne.com/decouvrir-la-plagne/domaine-skiable/plan-des-pistes",
  "espace-killy": "https://en.tignes.net/skiing/ski-area/ski-map",
  "chamonix": "https://en.chamonix.com/activities/winter/skiing",
  "zermatt-cervinia": "https://zermatt.swiss/en/map",
  "les-4-vallees": "https://verbier4vallees.ch/en/useful-information/interactive-map",
  "st-moritz": "https://www.stmoritz.com/live/anlagen-pisten",
  "ski-arlberg": "https://www.skiarlberg.at/en/live-info/map-navigation",
  "kitzbuhel": "https://map.kitzski.at/en/winter",
  "ischgl": "https://www.ischgl.com/en/winter/silvretta-arena/piste-map",
  "sella-ronda": "https://www.dolomitisuperski.com/en/experiences/winteractivities/ski-circuits/sellaronda",
  "cortina-dampezzo": "https://www.dolomitisuperski.com/en/areas/cortina-d-ampezzo",
  "whistler-blackcomb": "https://www.whistlerblackcomb.com/the-mountain/about-the-mountain/trail-maps.aspx",
  "jackson-hole": "https://www.jacksonhole.com/maps",
  "aspen-snowmass": "https://www.aspensnowmass.com/four-mountains",
  "mammoth": "https://www.mammothmountain.com/on-the-mountain/winter-trail-map",
  "niseko-united": "https://www.niseko.ne.jp/en/map/",
  "are": "https://www.skistar.com/en/ski-destinations/are/winter-in-are/piste-maps/",
  "lake-louise": "https://www.skilouise.com/fr/explore-winter/winter-ski-ride/lift-runs-parks-status/",
  "banff-sunshine": "https://www.skibanff.com/explore/trail-maps/",
  "park-city": "https://www.parkcitymountain.com/the-mountain/about-the-mountain/trail-map",
  "deer-valley": "https://www.deervalley.com/media-room/101725-updated-trail-map",
  "saalbach": "https://www.saalbach.com/en/winter/ski-resort/piste-map",
  "solden": "https://www.soelden.com/en/activities/winter/skiing-snowboarding/ski-area-information/ski-area-map-lifts-slopes",
  "obergurgl": "https://www.gurgl.com/en/activities/winter/skiing-snowboarding/ski-area-information/ski-area-map-lifts-slopes",
  "mayrhofen": "https://www.mayrhofen.at/de/stories/geoeffnete-anlagen-mayrhofner-bergbahnen-winter",
  "schladming": "https://www.schladming-dachstein.at/en/activities/skiing/piste-map",
  "laax": "https://www.laax.com/en/map",
  "davos": "https://www.davosklostersmountains.ch/en/mountains/winter/live-info/current-operating-infos?active=maps",
  "arosa-lenzerheide": "https://arosalenzerheide.swiss/en/Ski-Area/Skiing-Snowboarding/Ski-map",
  "engelberg": "https://www.engelberg.ch/en/open-trails/",
  "saas-fee": "https://www.saas-fee.ch/en/winter-activities/skiing-snowboarding",
  "andermatt": "https://www.andermatt-sedrun-disentis.ch/en/stories/skifahren-in-andermatt-sedrun-und-disentis",
  "madonna-di-campiglio": "https://www.ski.it/en/info-live/interactive-ski-map",
  "kronplatz": "https://www.kronplatz.com/en/the-kronplatz/skilifts-slopes/skimap",
  "livigno": "https://www.livigno.eu/hubfs/Outdoor%202025-2026_Digital.pdf",
  "monterosa": "https://monterosaski.eu/en/in-tempo-reale/skirama/monterosa-ski-3-valli",
  "alpe-dhuez": "https://www.alpedhuez.com/en/resort/resort-maps/",
  "les-deux-alpes": "https://www.les2alpes.com/hiver/skier-aux-2-alpes/domaine-skiable/secteurs-et-pistes/",
  "serre-chevalier": "https://www.serre-chevalier.com/en/ski-area/interactive-trail-map",
  "la-clusaz": "https://www.laclusaz.com/ski/plan-des-pistes/",
  "grandvalira": "https://www.grandvalira.com/en/resort/ski-map",
  "baqueira-beret": "https://www.baqueira.es/",
  "garmisch": "https://zugspitze.de/en/Service-information/Plan-your-trip/Downloads",
  "vail": "https://www.vail.com/the-mountain/about-the-mountain/trail-map.aspx",
  "breckenridge": "https://www.breckenridge.com/the-mountain/about-the-mountain/trail-map",
  "telluride": "https://tellurideskiresort.com/mountain/",
  "big-sky": "https://www.bigskyresort.com/trail-maps",
  "palisades-tahoe": "https://www.palisadestahoe.com/mountain-information/trail-maps",
  "revelstoke": "https://www.revelstokemountainresort.com/discover/about/trail-maps/",
  "hakuba": "https://www.hakubavalley.com/en/",
  "rusutsu": "https://rusutsu.com/wp-content/uploads/trailmap_en-1.pdf",
  "perisher": "https://www.perisher.com.au/plan-your-trip/new-to-perisher/trail-maps",
  "thredbo": "https://www.thredbo.com.au/the-mountain/mountain-map/",
  "cardrona": "https://cardrona-treblecone.com/mountains/maps",
  "coronet-peak": "https://www.coronetpeak.co.nz/mountain-info",
  "valle-nevado": "https://www.vallenevado.com/es/pistas/",
  "cerro-catedral": "https://catedralaltapatagonia.com/wp-content/uploads/2024/06/MAPA-DE-PISTAS-CATEDRAL-2024.pdf",
};

/** Summer references only. Entry-specific operator maps take priority. */
export const OFFICIAL_MTB_MAP_REFERENCES: Readonly<Record<string, string>> = {
  "portes-du-soleil": "https://en.portesdusoleil.com/in-summer/trail-map-for-mountain-biking-hiking-trail-running-cycling-gravel/",
  "les-4-vallees": "https://www.nendaz.ch/fr/Z13518/nos-itineraires-vtt-e-bike",
  ischgl: "https://www.ischgl.com/en/summer/silvretta-bike-arena",
  garmisch: "https://gapa-tourismus.de/en/Summer/Cycling%20and%20mountainbiking",
  "espace-killy": "https://www.valdisere.ski/fr/bikepark",
  chamonix: "https://domaineschamonix.montblancnaturalresort.com/en/page/mountain-bike",
  kitzbuhel: "https://map.kitzski.at/en/summer/",
  "sella-ronda": "https://www.dolomitisuperski.com/it/live-info/cartina/dolomiti-supersummer-bike-comprensori",
  "cortina-dampezzo": "https://www.impianticortina.it/en/mountain-bike-bike-park/",
  "whistler-blackcomb": "https://www.whistlerblackcomb.com/the-mountain/about-the-mountain/trail-maps.aspx",
  are: "https://www.skistar.com/en/ski-destinations/are/summer-in-are/biking/are-bike-park/",
  saalbach: "https://www.saalbach.com/en/summer/mountain-biking/interactive-trail-map",
  solden: "https://www.soelden.com/en/activities/summer/bike-republic-soelden/trails-tours-routes/bike-map",
  laax: "https://www.flimslaax.com/en/biken/bike-trails",
  davos: "https://www.davosklostersmountains.ch/en/mountains/summer/live-info/current-operating-information?active=maps",
  "arosa-lenzerheide": "https://www.bikekingdom.ch/de/Bikeparks/Bike-Kingdom-Park/Strecken",
  "madonna-di-campiglio": "https://www.ski.it/it/live/impianti-e-orari-estivi",
  "alpe-dhuez": "https://www.alpedhuez.com/wp-content/uploads/2026/06/ALPE-DHUEZ-PLAN-VTT-2026.pdf",
  "serre-chevalier": "https://www.serre-chevalier.com/en/altitude-area/maps-altitude-area-and-bike-park",
  "la-clusaz": "https://www.laclusaz.com/vtt/plan-vtt/",
  vail: "https://www.vail.com/the-mountain/about-the-mountain/trail-map.aspx",
  breckenridge: "https://www.breckenridge.com/explore-the-resort/about-the-resort/summer-arrival.aspx",
};
